export default {
  from: 'von',
  select: 'Prüfen',
  deal: 'Angebot',
  deals: 'Angebote',
  total: '',
  total_fr: 'Gesamt ',
  pp: 'p.P.',
}
